<template>
  <el-container class="home-container">
    <!-- 头部区域 -->
    <el-header>
      <div @click="goTo('welcome')">
        <img src
             alt />

        <span>TransEcs<br>数据整合平台</span>
      </div>
      <!-- :collapse="!sidebar.opened"
      :collapse-transition="false"-->
      <el-header>

        <el-menu mode="horizontal"
                 background-color="#333744"
                 :router="true"
                 menu-trigger="hover"
                 text-color="#fff"
                 active-text-color="#ffd04b"
                 unique-opened
                 :default-active="activePath">
          <!-- default-active="/welcome" -->
          <sub-menu ref="refSubMenu"
                    v-on:go="handleChange"
                    v-for="menu in menulist"
                    :key="menu.id"
                    :menu="menu"></sub-menu>

          <!-- <el-menu-item index="1" @click="goTo({name: 'BaseIndustry'})">行业</el-menu-item> -->
        </el-menu>
      </el-header>
      <div class="block">
        <!-- <el-avatar :size="40"
                   style="font-size: 18px;"
                   slot="reference">{{ username.charAt(0).toUpperCase() }}</el-avatar> -->
        <el-avatar :size="40"
                   style="font-size: 19px;"
                   icon="el-icon-user-solid"
                   slot="reference">{{ username.charAt(0).toUpperCase() }}</el-avatar>

        <!-- <el-avatar :size="50"
        style="margin-right: 10px;">{{ username }}</el-avatar>-->

        <!-- <el-dropdown trigger="click">
          <span class="el-dropdown-link"
                style="color:#C0C4CC">
            {{ username }}
            <i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item @click.native="goTo('welcome')">首页</el-dropdown-item>
            <el-dropdown-item @click.native="profile">个人信息</el-dropdown-item>

            <el-dropdown-item @click.native="logout">退出</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown> -->

        <el-dropdown placement="bottom">
          <span class="el-dropdown-link"
                style="color:#C0C4CC">
            {{ username }}
            <i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown"
                            class="change-ptncode">
            <el-dropdown-item icon="el-icon-s-home"
                              @click.native="goTo('/welcome')">&nbsp;首&nbsp;&nbsp;页</el-dropdown-item>
            <el-dropdown-item icon="el-icon-setting"
                              @click.native="profile">&nbsp;个人信息</el-dropdown-item>
            <el-dropdown-item icon="el-icon-back"
                              @click.native="logout">&nbsp;退&nbsp;&nbsp;出</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>

        <!-- <el-button type="info"
        @click="logout">退出</el-button>-->
      </div>
    </el-header>
    <el-container>
      <!-- 内容部分 -->
      <el-main class="page-main">
        <breadcrumb :list="BreadcrumbList"></breadcrumb>
        <router-view></router-view>
      </el-main>
      <!-- 个人信息修改 -->
      <el-dialog title="个人信息"
                 :visible.sync="dialogFormVisible"
                 @close="closeProfileform"
                 width="600px">
        <el-form :model="profileform"
                 :rules="rules"
                 ref="editformRef"
                 label-width="80px"
                 class="form-inline">
          <el-row class="dialog-row">
            <el-col :span="24">
              <el-form-item label="用户名"
                            prop="username">
                <el-input v-model="profileform.username"
                          :disabled="true"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="邮箱"
                            prop="email">
                <el-input v-model="profileform.email"
                          :disabled="true"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="手机号码"
                            prop="mobile">
                <el-input v-model="profileform.mobile"></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="24">
              <el-form-item label="密码"
                            prop="password">
                <el-input v-model="profileform.password"
                          @keyup.enter.native="saveUser"
                          type="password"></el-input>
              </el-form-item>
            </el-col>

          </el-row>
        </el-form>
        <template #footer>
          <span class="dialog-footer">
            <el-button @click="dialogFormVisible = false">取 消</el-button>
            <el-button type="primary"
                       @click="saveUser"
                       :loading="saveUserLoading">确 定</el-button>
          </span>
        </template>
      </el-dialog>
    </el-container>
  </el-container>
</template>



<script>
import { mapGetters } from 'vuex'
import Breadcrumb from '@/base/Breadcrumb'
import SubMenu from './SubMenu.vue'

export default {
  data() {
    // 验证手机号规则
    var checkMobile = (rule, value, callback) => {
      const regMobile = /^(13[0-9]|15[012356789]|15[012356789]|17[5678]|18[0-9]|19[0-9]|14[57])[0-9]{8}$/
      // 符合规则
      if (regMobile.test(value)) {
        return callback()
      }
      callback(new Error('请输入合法的手机号'))
    }
    return {
      menulist: [],
      // isCollapse: false,
      activePath: '', // 被激活的地址
      username: '',
      BreadcrumbList: [],
      dialogFormVisible: false,
      PartnerLists: '',
      profileform: {
        username: '',
        id: '',
        mobile: '',
        email: '',
        password: '',
      },
      saveUserLoading: false,
      rules: {
        password: [
          { required: false, message: '请输入密码', trigger: 'blur' },
          {
            min: 8,
            max: 20,
            message: '长度在 8 到 20 个字符',
            trigger: 'blur',
          },
        ],
        mobile: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { validator: checkMobile, trigger: 'blur' },
        ],
      },
    }
  },
  components: {
    Breadcrumb,
    SubMenu,
  },
  // 页面加载前执行
  created() {
    this.getMenuList()
    this.activePath = window.sessionStorage.getItem('activePath')
    this.saveNavstate(this.activePath)
    console.log('create this.activePath', this.activePath)
    this.getPartnerLists(this.activePath)
  },
  mounted() {
    // 监听浏览器前进后退 刷新 当前路径
    // 监听 hash 可能更好
    // window.onpopstate = this.handlePopState(e);
    // 以一种拧巴的方式处理了这个问题， forgive me
    // 用vuex sessionStorage 响应式数据连接 菜单和面包屑 参见https://panjiachen.github.io/vue-element-admin/#/login

    let _this = this
    window.onpopstate = function (e) {
      let hash = window.location.hash
      _this.activePath = hash.replace('#', '')

      let menulist = JSON.parse(window.sessionStorage.getItem('menulist'))
      let id
      function map(path, arr) {
        for (let item of arr) {
          if (item.children && item.children.length > 0) {
            map(path, item.children)
          } else {
            if (item.menuRoute === path) {
              id = item.id
            }
          }
        }
      }
      map(_this.$route.path, menulist)
      console.log('id"ddddd', id)
      console.log(
        '_this.$refs.refSubMenu',
        _this.$refs.refSubMenu[0].saveNavstate(_this.$route.path, id)
      )
    }
  },
  computed: {
    ...mapGetters(['sidebar']),
  },
  methods: {
    //打开个人设置弹窗
    profile() {
      this.profileform.id = window.sessionStorage.getItem('id')
      this.profileform.mobile = window.sessionStorage.getItem('mobile')
      this.profileform.username = window.sessionStorage.getItem('username')
      this.profileform.email = window.sessionStorage.getItem('email')
      this.dialogFormVisible = true
    },
    closeProfileform() {
      this.$refs.editformRef.resetFields()
    },
    // 保存用户更新
    saveUser() {
      this.$refs.editformRef.validate(async (valid) => {
        if (!valid) return
        if (this.saveUserLoading) return
        this.saveUserLoading = true
        await this.$http
          .post('updateSelf', this.profileform)
          .then((response) => {
            this.dialogFormVisible = false
            this.saveUserLoading = false
            this.$message({
              message: '更新成功,请重新登录',
              type: 'success',
              showClose: true,
              duration: 2000,
              onClose: () => {
                this.logout()
              },
            })
          })
          .catch((error) => {
            this.saveUserLoading = false
            return this.$message.error(error.response.data.message)
          })
      })
    },
    goTo(name) {
      // debugger;
      // console.log("this.$route;", this.$route);
      if (this.$route.name === name.name) return
      this.$router.push(name)
      this.BreadcrumbList = []
    },
    logout() {
      window.sessionStorage.clear()
      this.$router.push('/login')
    },
    // 获取所有的菜单
    async getMenuList() {
      // 菜单不是这样获取的， this.username 应该放在 Vuex
      // const { data: res } = await this.$http.post("menus");

      // if (res.meta.status !== 200) return this.$message.error(res.meta.msg);
      this.username = window.sessionStorage.getItem('username')
      this.menulist = JSON.parse(sessionStorage.getItem('menulist'))
      // window.sessionStorage.setItem("menulist", JSON.stringify(res.data));
      // console.log(this.menulist);
    },
    // 点击按钮 切换菜单的折叠、展开np
    toggleCollapse() {
      // this.isCollapse = !this.isCollapse;
      this.$store.dispatch('app/toggleSidebar', { withoutAnimation: false })
    },
    // 保存菜单index
    saveNavstate(activePath) {
      window.sessionStorage.setItem('activePath', activePath)
      this.activePath = activePath
      // 根据actiivePath 找父级， 拧巴一个数组
      // 无限层级 由 id和parentId 构建的数组 合理，

      this.BreadcrumbList = JSON.parse(
        window.sessionStorage.getItem('breadcrumb-list')
      )
    },
    handleChange() {
      console.log('handleChange')
      this.BreadcrumbList = JSON.parse(
        window.sessionStorage.getItem('breadcrumb-list')
      )
    },
    // 获取商家列表
    async getPartnerLists() {
      const { data: res } = await this.$http.post('ptnlists', {
        query: '',
        pagenum: 1,
        pagesize: 100,
      })

      if (res.meta.status !== 200)
        return this.$message.error('获取商家列表失败')
      this.PartnerLists = res.data.data
    },
  },
}
</script>

<style lang='scss' scoped>
.el-header {
  background-color: #333744;
  display: flex;
  justify-content: space-between;
  padding-left: 0;
  align-items: center;
  color: #fff;
  // font-weight: bold;
  font-size: 16px;
  > div {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    cursor: pointer;
 
    span {
      margin-left: 10px;
    }
  }
}
.block {
  margin-right: 10px;

  // width: 150px;
}
.el-aside {
  background-color: #333744;
  .el-menu {
    border: none;
  }
}
.el-main {
  background-color: #eaedf1;
}
.home-container {
  height: 100%;
  
}
.toggle-button {
  background-color: #4a5064;
  font-size: 10px;
  line-height: 24px;
  color: #fff;
  text-align: center;
  letter-spacing: 0.2em;
  cursor: pointer;
  
}

.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
}
.el-icon-arrow-down {
  font-size: 12px;
}
// .el-menu-item {
//   height: 42px;
//   line-height: 42px;
// }
.el-submenu {
  .el-submenu__title {
    height: 50px;
    line-height: 50px;
  }
}

//  .el-menu-item,>>> .el-submenu__title {

//      width: 105px;
//  }

// .menuitem >>> {
//   .el-menu--horizontal .el-menu .el-menu-item {
//     width: 180px;
//   }
// }
// .page-main {
//   padding: 7vh;
// }
.change-ptncode {
  background-color: #333744;
  opacity: 0.8;
  color: #fff;
  border: 1px solid #4a5064;
  // font-size: ;
  li {
    color: #fff;
  }
  .is-disabled {
    color: rgb(131, 130, 130);
  }
  .el-dropdown-menu__item:focus,
  .el-dropdown-menu__item:not(.is-disabled):hover {
    background-color: #000 !important;
    opacity: 0.8;
    color: #fff;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/common/Home.vue